<template>
  <v-container fluid>
    <v-layout justify-start column fill-height mx-2 mb-4 style="padding: 0 7px;">
      <v-tabs
        slot="extension"
        v-model="tabIndex"
        color="#1D2126"
        dark
      >
        <v-tabs-slider color="blue"></v-tabs-slider>
        <v-tab
          v-for="item in user_index"
          :key="item"
          v-model="selectedIndex"
          @click.native="getIndexName();"
        >
          {{ item }}
        </v-tab>
      </v-tabs>
    </v-layout>
    <v-flex px-2>
      <top-search-bar @setTime="setTime" @setRefreshTime="setRefreshTime" :textTemp="textTemp" :selectedIndex="user_index[tabIndex]"></top-search-bar>
    </v-flex>
    <v-tabs-items v-model="tabIndex">
      <v-container fluid grid-list-lg grid-list-md>
        <v-layout row warp>
          <raw-table :startTime="startTime" :endTime="endTime" :user_index="selectedIndex" :user_inst="user_inst" :username="username" :refreshTime="refreshTime"></raw-table>
        </v-layout>
      </v-container>
    </v-tabs-items>
  </v-container>
</template>

<script>
import jwtDecode from 'jwt-decode'
import rawTable from '@/components/rawTable'
import topSearchBar from '@/components/topSearchBar'
import axios from 'axios'
export default {
  name: 'raw',
  components: {
    topSearchBar,
    rawTable
  },
  data () {
    return {
      user_inst: '',
      token: '',
      user_index: '',
      user_id: '',
      username: '',
      decoded: '',
      index: '',
      startTime: 'now-15m',
      endTime: 'now',
      isLoading: true,
      tabIndex: 0,
      selectedIndex: '',
      refreshTime: 0
    }
  },
  created () {
    this.token = sessionStorage.getItem('user-token')
    this.decoded = jwtDecode(this.token)
    this.user_id = this.decoded._id
    this.user_index = this.decoded.index
    this.user_inst = this.decoded.instance
    this.username = this.decoded.username
    this.selectedIndex = this.user_index[this.tabIndex]
    this.getIndex()
  },
  methods: {
    async getIndex () {
      let response = await axios.post(apiUrl + '/api/query/getAllIndex', {
          command: 'user',
          id: this.user_id
      })
      if (response) {
        let index = [...new Set(response.data)]
         this.user_index = index
      } else {
         this.user_index = this.decoded.index
      }
    },
    setTime (startTime, endTime) {
      this.startTime = startTime
      this.endTime = endTime
    },
    setRefreshTime (refreshTime) {
      this.refreshTime = refreshTime
    },
    getIndexName () {
      this.selectedIndex = this.user_index[this.tabIndex]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/rawData.vue